import { NOTICE_TYPES } from "lib/const";
import moment from "moment";
import { Link, useLocation, useParams } from "react-router-dom";

export const NoticeListItem = ({notice})=>{
    const location = useLocation();
    const { school } = useParams();

    return (
        <div className={`list ${notice.isNotice==='Y'?'top_notice':''}`}>
            <div className="num">{notice.id}</div>
            <div className="type"><span className={`type${notice.isNotice==='Y'?'NOTICE_TOP':notice.type}`}>{NOTICE_TYPES[notice.type]}</span></div>
            <div className="title">
                <Link to={`/${school}/notice/${notice.id}${location.search}`}>
                    {notice.title}
                    { notice.hasImageFile && <i key="image" className="icon far fa-image"></i> }
                    { notice.hasNoImageFile && <i key="file" className="icon far fa-file"></i>}
                </Link>
            </div>
            <div className="hit">{notice.readCount}</div>
            <div className="date">{moment(notice.createdAt).format('YYYY.MM.DD')}</div>
        </div>
    );
};